import React from "react";

import { Box, IconButton, Typography, Avatar, Chip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

import { getRoleColor } from "../../auth/roles";
import DataTable from "../../ui/Table";

function EmployeeTable({
  employees,
  loading,
  onEdit,
  onDelete,
  selectedIds = [],
  onSelectionChange
}) {
  const sortedEmployees = [...employees].sort(
    (a, b) => a.employee_id - b.employee_id
  );

  const columns = [
    {
      key: "employee_name",
      label: "Employee Name",
      render: (employee) => (
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar
            src={employee.profile_picture || undefined}
            sx={{ width: 34, height: 34, fontSize: 14 }}
          >
            {employee.employee_name?.charAt(0)}
          </Avatar>

          <Box>
            <Typography fontSize={14} fontWeight={600}>
              {employee.employee_name}
            </Typography>

            <Typography fontSize={12} color="#94a3b8">
              {employee.designation || "N/A"}
            </Typography>
          </Box>
        </Box>
      )
    },
    {
      key: "email",
      label: "Email",
      render: (employee) => (
        <Typography fontSize={14} color="#475569">
          {employee.email}
        </Typography>
      )
    },
    {
      key: "department_name",
      label: "Department",
      render: (employee) => (
        <Chip
          label={employee.department_name || "N/A"}
          size="small"
          sx={{ fontWeight: 500, fontSize: 12, background: "#eff6ff", color: "#2563eb" }}
        />
      )
    },
    {
      key: "role_name",
      label: "Role",
      render: (employee) => (
        <Chip
          label={(employee.role_name || "member").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
          size="small"
          sx={{ fontWeight: 600, fontSize: 11, ...getRoleColor(employee.role_name) }}
        />
      )
    },
    {
      key: "manager_name",
      label: "Manager",
      render: (employee) => (
        <Typography fontSize={13} color="#475569">
          {employee.manager_name || "N/A"}
        </Typography>
      )
    },
    {
      key: "actions",
      label: "Actions",
      width: 110,
      render: (employee) => (
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <IconButton
            onClick={() => onEdit(employee)}
            sx={{ background: "#eff6ff", width: 32, height: 32 }}
          >
            <EditIcon fontSize="small" sx={{ color: "#2563eb" }} />
          </IconButton>

          <IconButton
            onClick={() => onDelete(employee)}
            sx={{ background: "#fef2f2", width: 32, height: 32 }}
          >
            <DeleteIcon fontSize="small" sx={{ color: "#ef4444" }} />
          </IconButton>
        </Box>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      rows={sortedEmployees}
      loading={loading}
      rowKey={(employee) => employee.employee_id}
      selectable
      selectedIds={selectedIds}
      onSelectionChange={onSelectionChange}
      rowsPerPage={50}
      emptyState={{
        icon: PeopleAltOutlinedIcon,
        title: "No employees found",
        subtitle: "Try changing search text or add a new employee to start building your team list."
      }}
    />
  );
}

export default EmployeeTable;
